// tslint:disable:ordered-imports
// Import order is important here.
import './polyfills';
import './publicpath';

import { configureSentry } from './sentry';

import '@atlaskit/css-reset';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';

import Analytics from './context/Analytics';
import Start from './ui/Start';
import ErrorBoundary from './ui/ErrorBoundary/ErrorBoundary';
import { analyticsClient, store } from './singletons';

import { ExperienceTracker, ExperienceTrackerContext } from '@atlassian/experience-tracker';

const experienceTracker = new ExperienceTracker();
configureSentry();

// For easier debugging
window.__MOBX_APP_STATE__ = store;

// To avoid updating mobx state outside of an action block
configure({
  enforceActions: 'observed',
});

// TODO: replace this with UFO
// #region Mark the start of SLOs tracking
// metricsClient.ui.startTracking(Task.PRODUCTS_ROW_LOADING, window._uchi_pageloadTiming);
// //#endregion

window.addEventListener('beforeunload', function onBeforeUnload() {
  // TODO: replace this with UFO
  // metricsClient.ui.stopAllTracking();
  experienceTracker.abort({ reason: 'window-unloading' });
});

ReactDOM.render(
  <ErrorBoundary subject="root">
    <Provider {...store}>
      <Analytics.Provider value={analyticsClient}>
        <ExperienceTrackerContext.Provider value={experienceTracker}>
          <Start />
        </ExperienceTrackerContext.Provider>
      </Analytics.Provider>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
);
